import React from 'react';
import FollowUpOrder from './follow-up-order';
import { CONTACT_DETAILS } from '../constants';
function ContactDetails() {
  return <div className='col-span-full md:col-span-6' data-sentry-component="ContactDetails" data-sentry-source-file="contact-details.tsx">
            <h1 className='mb-1.5 text-body-14 font-bold md:mb-8 md:text-body-16'>تماس با ما</h1>
            <span className='mb-4 block text-body-14 md:mb-6 md:text-body-16'>
                شما می‌توانید از روش‌های زیر با خانومی در ارتباط باشید:
            </span>

            <div className='mb-1 flex flex-col gap-2 md:mb-18 md:gap-4'>
                {CONTACT_DETAILS.map(item => {
        return <div key={item.title} className='flex h-fit items-center justify-between gap-1 text-body-14 last:!items-start md:text-body-16'>
                            <span className='whitespace-nowrap font-medium'>{item.title}:</span>
                            {item.value}
                        </div>;
      })}
            </div>
            <FollowUpOrder showDevice='desktop' data-sentry-element="FollowUpOrder" data-sentry-source-file="contact-details.tsx" />
        </div>;
}
export default ContactDetails;